(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hello-world"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hero = document.querySelector('[data-hero]');
    if (!hero) return;
    const track = hero.querySelector('[data-hero-track]');
    const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
    if (!track || slides.length < 2) return;

    const AUTO_MS = 5500;
    let index = 0;
    let timer = null;
    let paused = false;

    const setActive = (i) => {
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      index = i;
    };

    const goTo = (i) => {
      const n = slides.length;
      const next = ((i % n) + n) % n;
      track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
      setActive(next);
    };

    const tick = () => { if (!paused) goTo(index + 1); };

    const start = () => { stop(); timer = setInterval(tick, AUTO_MS); };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

    dots.forEach((dot, i) => dot.addEventListener('click', () => { goTo(i); start(); }));

    hero.addEventListener('mouseenter', () => { paused = true; });
    hero.addEventListener('mouseleave', () => { paused = false; });

    let scrollDebounce;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index) setActive(i);
      }, 80);
    }, { passive: true });

    // Pause while off-screen
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { paused = !e.isIntersecting; });
      }, { threshold: 0.2 });
      io.observe(hero);
    }

    window.addEventListener('resize', () => {
      track.scrollTo({ left: index * track.clientWidth, behavior: 'auto' });
    });

    start();
  })();

  } catch(e) { console.error(e); }
})();
})();
